const entranceTypes = {
    NONE: 0,
    MODERN: 1,
    WOODEN: 2
}

export default entranceTypes